export enum UserCreationStatus {
  created = 'created',
  alreadyExist = 'alreadyExist',
  unknownError = 'unknownError',
}
